<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <!-- <el-row>
      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.id.label" :prop="fields.id.name">
          <el-input v-model="model[fields.id.name]"/>
        </el-form-item>
      </el-col>

      <el-col style="margin-bottom: -0.41px;" :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.createdAt.label" :prop="fields.createdAt.name">
          <el-date-picker type="datetimerange" v-model="model[fields.createdAt.name]" />
        </el-form-item>
      </el-col>
    </el-row>

    <div class="filter-buttons">
      <el-button :disabled="loading" @click="doFilter" icon="el-icon-fa-search" type="primary">
        <app-i18n code="common.search" />
      </el-button>

      <el-button :disabled="loading" @click="doResetFilter" icon="el-icon-fa-undo">
        <app-i18n code="common.reset" />
      </el-button>
    </div> -->
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { StripePayoutModel } from '@modules/stripe/stripe-payout/stripe-payout-model';

const { fields } = StripePayoutModel;

const filterSchema = new FilterSchema([
  fields.id,
  fields.subproperty,
  fields.program,
  fields.subprogram,
]);

export default {
  name: 'app-stripe-payout-list-filter',

  data() {
    return {
      rules: filterSchema.rules(),
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'stripePayout/list/loading',
      filter: 'stripePayout/list/filter',
      currentManage: 'auth/manage/currentManage',
    }),

    fields() {
      return fields;
    },
    subpropertyId({ currentManage: { subpropertyId }}) {
      return subpropertyId;
    },
  },

  async mounted() {
    this.model = filterSchema.initialValues(
      { ...this.filter,
        subproperty: this.subpropertyId 
      },
      this.$route.query,
    );
    return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'stripePayout/list/doReset',
      doFetch: 'stripePayout/list/doFetch',
    }),

    async doResetFilter() {
      this.model = filterSchema.initialValues(
        { subproperty: this.subpropertyId }
      );
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async doFilter() {
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
    },
  },
};
</script>

<style>
</style>
